module.exports = __webpack_public_path__ + "static/media/select-a-product.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/select-a-product.svg
// module id = 489
// module chunks = 0